import { Box, Stack } from "@mui/material";
import React from "react";
import DetailsTreeContainer from "../../../../shared-components/hoa-view-details-draw-container";

import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import {
	StringComponentForViolationRegulation,
	ArrayComponentForViolationRegulation,
	ObjectComponentForViolationRegulation,
} from "../../../../shared-components/hoa-view-tabs-item-component";

const processItem = (item: any): React.ReactNode[] =>
	Object.entries(item).flatMap(([key, value]) => {
		if (typeof value === "string") {
			return <StringComponentForViolationRegulation key={key} title={key} value={value} />;
		} else if (Array.isArray(value)) {
			return <ArrayComponentForViolationRegulation key={key} title={key} value={value} />;
		} else if (typeof value === "object") {
			return <ObjectComponentForViolationRegulation key={key} title={key} value={value} />;
		}
		return null;
	});

const ViolationComponent: React.FC<{ details: any; tabDetails: any }> = ({
	details,
	tabDetails,
}) => {
	const [value, setValue] = React.useState("Landscaping");

	const handleChange = (event: React.SyntheticEvent, newValue: string) => {
		setValue(newValue);
	};

	const Tabs = Object.keys(tabDetails);

	return (
		<Stack>
			{Object.entries(details).map(([key, value]: any) => {
				return (
					value.length > 0 && (
						<Stack
							sx={{ position: "relative" }}
							key={key}
							borderBottom={"1px solid #E8E8E8"}
						>
							<Stack m={3}>
								<span className="text-3E3E3E-18px">{key}</span>
								<DetailsTreeContainer
									key={key}
									data={value}
									processItem={processItem}
								/>
							</Stack>
						</Stack>
					)
				);
			})}
			<TabContext value={value}>
				<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
					<TabList onChange={handleChange}>
						{Tabs.map((label) => (
							<Tab key={label} label={label} value={label} />
						))}
					</TabList>
				</Box>
				{Tabs.map((label, index) => (
					<TabPanel sx={{ padding: "0px" }} key={label} value={label}>
						{Object.entries(tabDetails[label]).flatMap(([key, value]: any) => {
							return (
								<Stack key={key}>
									<span
										style={{
											padding: "18px",
											background: "#FAFAFA",
											border: "1px solid var(--secondary-50-e-8-e-8-e-8, #E8E8E8)",
										}}
										className="text-3E3E3E-18px"
									>
										{key}
									</span>
									<Stack m={3}>
										<DetailsTreeContainer
											key={key}
											data={value}
											processItem={processItem}
										/>
									</Stack>
								</Stack>
							);
						})}
					</TabPanel>
				))}
			</TabContext>
		</Stack>
	);
};

export default ViolationComponent;
